export default __webpack_public_path__ + "static/media/2-QUIFAITQUOI-EN.25012d3d.pdf";